var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C5.188 5 1 11 1 11C1 11 5.188 17 12 17C18.812 17 23 11 23 11C23 11 18.812 5 12 5ZM12 15C8.057 15 5.074 12.516 3.621 11C4.661 9.915 6.483 8.343 8.875 7.531C8.3117 8.23091 8.00314 9.10157 8 10C8 11.0609 8.42143 12.0783 9.17157 12.8284C9.92172 13.5786 10.9391 14 12 14C13.0609 14 14.0783 13.5786 14.8284 12.8284C15.5786 12.0783 16 11.0609 16 10C15.9969 9.10157 15.6883 8.23091 15.125 7.531C17.518 8.343 19.341 9.916 20.379 11C18.924 12.518 15.942 15 12 15Z",
    fill: "#5A5C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.301ae5a22dc103f3c6e60a194cbb3796.svg";
export { ForwardRef as ReactComponent };